import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { SnippetsOutlined } from "@ant-design/icons";
import { updateAuth } from "../../Redux/AuthSlice";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../Utility/API";
import toast from "react-hot-toast";
import r0 from "../../Assets/Images/R0.png";
import r1 from "../../Assets/Images/R1.png";
import r2 from "../../Assets/Images/R2.png";
import logo from "../../Assets/Images/logo.png";
import Fleg from "../../Assets/Header/Flag.png";
import GrapH1 from "../../Assets/Dasahboard/graph.png";
import Vol from "../../Assets/Dasahboard/Volume.png";
import Bat from "../../Assets/Dasahboard/bactch.png";
import GRAPH from "../../Assets/Dasahboard/Stats.png";
import Arrow from "../../Assets/Dasahboard/Icon.png";
import Eye from "../../Assets/Dasahboard/eye-slash.png";
import cardImage from "../../Assets/sidebar/gameimage.png";
import cardImage2 from "../../Assets/sidebar/gameimage2.png";
import IconA from "../../Assets/sidebar/icon1.png";
import SidebarFIX from "../Sidebar/SidebarFIX";

export default function DashboardFIX() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dash, setdataArray] = useState([]);
  const { userId, jwtToken } = useSelector((state) => state.Auth);

  const [currenttimer, setcurrenttimer] = useState(0);
  const [Days_here_booster, setDays_here_booster] = useState(0);
  const [Hours_here_booster, setHours_here_booster] = useState(0);
  const [Munits_here_booster, setMunits_here_booster] = useState(0);
  const [Seconds_booster, setSeconds_booster] = useState(0);
  const [liverate, setliverate] = useState("");
  const [withdrawalToken, setwithdrawalToken] = useState("");
  const [News, setNews] = useState([]);
  // const [NotificationCount, setNotificationCount] = useState("");

  const Dashboard_API = async () => {
    try {
      let responce = await API?.post(
        "userdashboard",
        {
          uid: userId,
          type: 1,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      console.log("responceDashboard", responce.data.data[0]);
      responce = responce.data.data[0];

      setdataArray(responce);
    } catch (e) {
      console.log("Error While calling dashboard API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({ aexnglobalAuth: false, userId: null, jwtToken: null })
        );
        navigate("/");
      }
    }
  };

  const News_API = async () => {
    try {
      let responceNews = await API?.post(
        "userNews",
        {
          username: userId,
          var: 5,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      //console.log("responceNews", responceNews.data?.data?.record[0]);
      responceNews = responceNews.data?.data?.record[0];

      setNews(responceNews);
    } catch (e) {
      console.log("Error While calling news API", e);
      if (
        e?.response?.data?.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({ aexnglobalAuth: false, userId: null, jwtToken: null })
        );
        navigate("/");
      }
    }
  };

  let URL = window.location.origin;
  const CopyLeftReferralLink = () => {
    const text = `${URL}/register?userid=${userId}&position=1`;
    //  `${URL}/registration?userid=${user}`
    navigator.clipboard.writeText(text);
    toast.success("Copied");
  };

  const CopyRightReferralLink = () => {
    const text = `${URL}/register?userid=${userId}&position=2`;
    //  `${URL}/registration?userid=${user}`
    navigator.clipboard.writeText(text);
    toast.success("Copied");
  };

  useEffect(() => {
    Dashboard_API();
    News_API();
  }, []);

  // Toggle sidebar function
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <div className="container-fluid NewDashboard">
        <div className="row">
          <div
            className={` ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          >
            <SidebarFIX />
          </div>
          <div className="col-lg-2 px-0 order-2">
            <div className="sidebarLeft px-3 position-relative">
              <div className="leftisidelogo">
                <img className="h-100 w-100" src={logo} alt="" />
              </div>
              <ul className="itemssidebar">
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    FIX Investment
                  </Link>
                  {dash?.Fixpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    ALGO TRADING Investment
                  </Link>
                  {dash?.FixTradingpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    ADV. TRADING Investment
                  </Link>
                  {dash?.FixAdvTradingpackage}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Total Income
                  </Link>
                  ${dash.TotalIncome}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Withdrawal Amount
                  </Link>
                  ${dash.WithDrawal_Amount}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Net Balance
                  </Link>{" "}
                  ${dash?.Net_Balance}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-10 px-0 order-lg-2 order-1">
            <div className="contentside">
              <div className="row mx-0">
                <div className="col-12 px-0">
                  <header className="header ps-0">
                    <div className="hdleft d-flex align-items-center">
                      <div className="namelogo ps-3"></div>
                    </div>
                    <div className="rightside">
                      {/* <div className="dropdown dropdow1">
                        <Link
                          className="btn btnsecondary text-back"
                          to="/Notification">
                          🔔{" "}
                          <span className="btn headerbtn">
                            {" "}
                            {NotificationCount}{" "}
                          </span>
                        </Link>
                      </div> */}
                      <div className="dropdown dropdow2 d-none d-md-block">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="text1">
                            <p className="mb-1">ID Number</p>
                            <p className="mb-0 fw-bold text-start">{userId} </p>
                          </span>
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu p-2">
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <div className="dropdown dropdow2 d-block d-md-none">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="#">
                              Id Number <span>{userId}</span>
                            </Link>
                          </li>
                          <li className="text-white walltadd dropdown-item">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <a href="/DashboardBOT">
                        <button className="btn headerbtn">MAGIC PLAN</button>
                      </a>
                      <button
                        className="btn border-0 togglebtn"
                        id="togglebtn"
                        onClick={toggleSidebar}
                      >
                        <i
                          className={`fas fa-bars text-white ${
                            isSidebarOpen ? "" : "collapsed"
                          }`}
                        ></i>
                      </button>
                    </div>
                  </header>
                </div>
                <div className="col-12">
                  <div className="contentsidesec w-100 pt-3">
                    <div className="card cardsss cardes">
                      <div className="card-body">
                        <div className="invoice-content1 ps ps--active-y mt-4">
                          <i className="fa fa-star tra" />
                          <h3>
                            Join
                            <br />
                            Premium
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div
                          className="compaytext"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={CopyLeftReferralLink}
                        >
                          <h3 className="text-black">Affiliate Link Left</h3>
                          <button
                            style={{
                              MarginTop: "10px",
                              cursor: "pointer",
                            }}
                            className="btn btntop"
                          >
                            {" "}
                            <span className="me-2">
                              <SnippetsOutlined />
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div
                          className="compaytext"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={CopyRightReferralLink}
                        >
                          <h3 className="text-black">Affiliate Link Right</h3>
                          <button
                            style={{
                              MarginTop: "10px",
                              cursor: "pointer",
                            }}
                            className="btn btntop"
                          >
                            {" "}
                            <span className="me-2">
                              <SnippetsOutlined />
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mx-0">
                <div className="col-lg-6">
                  <div className="card leftsidecardpoint">
                    <div className="card-body">
                      <div className="card-heading">
                        <i class="fa fa-user tra"></i> Personal Details
                      </div>

                      <div className="headingss">
                        <div className="totlalPoint">
                          <div className="leftside">Member Name</div>
                          <div className="pont">{dash.f_name}</div>
                        </div>
                        <div className="totlalPoint">
                          <div className="leftside">Registration Date</div>
                          <div className="pont">{dash.joiningdate}</div>
                        </div>
                        <div className="totlalPoint">
                          <div className="leftside">Activation Date</div>
                          <div className="pont">{dash.fixActivatedate}</div>
                        </div>
                        <div className="totlalPoint">
                          <div className="leftside">Phone</div>
                          <div className="pont">{dash.mobile}</div>
                        </div>
                        <div className="totlalPoint">
                          <div className="leftside">Email</div>
                          <div className="pont">{dash.email}</div>
                        </div>
                        <div className="totlalPoint">
                          <div className="leftside">User Id</div>
                          <div className="pont">{dash.uid}</div>
                        </div>
                      </div>
                      <a href="/Profile">
                        <button class="viewalls">View Details</button>
                      </a>
                    </div>
                  </div>
                  <br></br>

                  <div className="card bottomcard" style={{ display: "none" }}>
                    <div className="card-body">
                      <div className="Ankercard">
                        <marquee
                          className="newsmarpuee text-black"
                          //width="40%"
                          direction="up"
                          height="170px"
                          scrollamount="3"
                        >
                          {News.map((item, index) => (
                            <h6
                              key={index}
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: item.content,
                              }}
                            />
                          ))}
                        </marquee>
                        {/* <span>
                                    <img
                                      className="w-100 h-100"
                                      src={Arrow}
                                      alt=""
                                    />
                                  </span> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="row mx-0">
                    <div className="card leftsidecard mb-3">
                      <div className="card-body">
                        <div className="card-heading">
                          <i class="fa fa-user tra"></i>Fix Subscription
                        </div>

                        <div className="twocrow">
                          <div className="crow">
                            <div className="card samecard1 mt-3 mb-3 w-100">
                              <div className="card-body">
                                <div className="row mx-0">
                                  <div className="col-8 ps-0">
                                    <h4 className="mb-2 text-black">
                                      SECURE Plan
                                    </h4>
                                    <div className="heading">
                                      {dash.Fixpackage} ({dash.fixActivatedate})
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="eyeimage">
                                      <a href="/Activate_HistorySECURE">
                                        <button class="viewalls">View</button>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card samecard1 mt-3 mb-3 w-100">
                              <div className="card-body">
                                <div className="row mx-0">
                                  <div className="col-8 ps-0">
                                    <h4 className="mb-2 text-black">
                                      ALGO TRADING Plan
                                    </h4>
                                    <div className="heading">
                                      {dash.FixTradingpackage} (
                                      {dash.FixTradingActivatedate})
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="eyeimage">
                                      <a href="/Activate_HistoryALGOTRADING">
                                        <button class="viewalls">View</button>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card samecard1 mt-3 mb-3 w-100">
                              <div className="card-body">
                                <div className="row mx-0">
                                  <div className="col-8 ps-0">
                                    <h4 className="mb-2 text-black">
                                      ADVANCE TRADING Plan
                                    </h4>
                                    <div className="heading">
                                      {dash.FixAdvTradingpackage} (
                                      {dash.FixAdvTradingpackageDate})
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="eyeimage">
                                      <a href="/Activate_HistoryADVTRADING">
                                        <button class="viewalls">View</button>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mx-0 pt-3">
              <div class="card-heading mb-4">
                <i class="fa fa-user tra"></i> Team Summary
              </div>

              <div className="col-lg-12 ps-lg-0">
                <div className="row mx-0">
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/DirectTeamFIX">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-12 ps-0">
                              <p>My Direct</p>
                            </div>
                            <div className="col-12 ps-0">
                              <div className="row">
                                <div className="col-6">
                                  <p>Left</p>
                                  <p>
                                    <span className="greentext">
                                      {dash.LeftActDirect}
                                    </span>
                                    /
                                    <span className="redtext">
                                      {dash.LeftInActDirect}
                                    </span>
                                  </p>
                                </div>
                                <div className="col-6">
                                  <p>Right</p>
                                  <p>
                                    <span className="greentext">
                                      {dash.RightActDirect}
                                    </span>
                                    /
                                    <span className="redtext">
                                      {dash.RightInActDirect}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/DownLineTeamFIX">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-12 ps-0">
                              <p>My Team</p>
                            </div>
                            <div className="col-12 ps-0">
                              <div className="row">
                                <div className="col-6">
                                  <p>Left</p>
                                  <p>
                                    <span className="greentext">
                                      {dash.LeftActTeam}
                                    </span>
                                    /
                                    <span className="redtext">
                                      {dash.LeftInActTeam}
                                    </span>
                                  </p>
                                </div>
                                <div className="col-6">
                                  <p>Right</p>
                                  <p>
                                    <span className="greentext">
                                      {dash.RightActTeam}
                                    </span>
                                    /
                                    <span className="redtext">
                                      {dash.RightInActteam}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="card samecard mb-3 w-100">
                      <div className="card-body">
                        <div className="row mx-0">
                          <div className="col-12 ps-0">
                            <p>Team Business</p>
                          </div>
                          <div className="col-12 ps-0">
                            <div className="row">
                              <div className="col-6">
                                <p>Left</p>
                                <p>${dash.leftbv}</p>
                              </div>
                              <div className="col-6">
                                <p>Right</p>
                                <p>${dash.rightbv}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="card samecard mb-3 w-100">
                      <div className="card-body">
                        <div className="row mx-0">
                          <div className="col-12 ps-0">
                            <p>Level Open</p>
                          </div>
                          <div className="col-12 ps-0">
                            <div className="row">
                              <div className="col-6">
                             
                                <p>{dash.LevelOpenfix}</p>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
            <div className="row mx-0 pt-3">
              <div class="card-heading mb-4">
                <i class="fa fa-user tra"></i> Income Summary
              </div>

              <div className="col-lg-12 ps-lg-0">
                <div className="row mx-0">
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/DirectIncomeFix">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Direct Income</p>
                              <div className="heading">
                                ${dash.directincome}
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/ROIIncomefix">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Trading Income</p>
                              <div className="heading">
                                ${dash.roiincome}
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/ROIlevelIncomefix">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Trading Level Income</p>
                              <div className="heading">
                                ${dash.roilevelincome}
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/CashBackIncomeFix">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Cashback Income</p>
                              <div className="heading">$0</div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  {/* <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/DirectIncomeFixTrading">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Algo Direct Income</p>
                              <div className="heading">
                                ${dash.DirectIncomeTrading}
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div> */}
                  {/* <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/TradingIncomeFIX">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Trading Income</p>
                              <div className="heading">$</div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div> */}
                  {/* <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/TradingLevelIncomeFIX">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Algo Trading Level Income</p>
                              <div className="heading">
                                ${dash.RoiLevelIncomeTrading}
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div> */}
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/MatchingIncomeFIX">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Matching Income</p>
                              <div className="heading">
                                ${dash.MatchingIncomeTrading ??0}
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/RewardInomeFIX">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Reward Income</p>
                              <div className="heading">
                                ${dash.RewardIncome??0}
                                {/* <br /> {dash.RewardIncome} */}
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
               
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/RewardInomeFIX">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Reward Rank</p>
                              <div className="heading">
                                {dash.TradingRankName??'N/A'}
                                {/* <br /> {dash.RewardIncome} */}
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/SilveGoldincomeFraFix">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Franchisee Income</p>
                              <div className="heading">
                                ${dash.Franchisee_Silver_Gold_income??0}
                              
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/SilveGoldincomeFraFix">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <p>Franchisee Rank</p>
                              <div className="heading">
                                {dash.FranchiseeNameRank??0}
                              
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="card samecard mb-3 w-100">
                      <div className="card-body">
                        <div className="row mx-0">
                          <div className="col-10 ps-0">
                            <p>Total Income</p>
                            <div className="heading">${dash.TotalIncome}</div>
                          </div>
                          <div className="col-2">
                            <div className="eyeimage">
                              <img className="w-100 h-100" src={Eye} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="card samecard mb-3 w-100">
                      <div className="card-body">
                        <div className="row mx-0">
                          <div className="col-10 ps-0">
                            <p>Withdrawal Amount</p>
                            <div className="heading">
                              ${dash.WithDrawal_Amount}
                            </div>
                          </div>
                          <div className="col-2">
                            <div className="eyeimage">
                              <img className="w-100 h-100" src={Eye} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="card samecard mb-3 w-100">
                      <div className="card-body">
                        <div className="row mx-0">
                          <div className="col-10 ps-0">
                            <p>Net Balance</p>
                            <div className="heading">${dash.Net_Balance}</div>
                          </div>
                          <div className="col-2">
                            <div className="eyeimage">
                              <img className="w-100 h-100" src={Eye} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mx-0 mb-5 pt-3">
              <div className="col-lg-6 col-md-6 col-sm-6">
                <div className="card leftsidecardpoint">
                  <div class="card-heading mb-4 ms-3 mt-3">
                    <i class="fa fa-user tra"></i> All Income
                  </div>
                  <div className="card-body text-center pt-0 pb-2">
                    <div id="morris_donught" className="custome-donut">
                      <center>
                        <svg
                          height={168}
                          version="1.1"
                          width="259.016"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          style={{
                            overflow: "hidden",
                            position: "relative",
                            left: "-0.5px",
                            top: "-0.921875px",
                          }}
                        >
                          <desc
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            }}
                          >
                            Created with Raphaël 2.2.0
                          </desc>
                          <defs
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            }}
                          />
                          <path
                            fill="none"
                            stroke="#e085e4"
                            d="M129.508,133.33333333333334A49.333333333333336,49.333333333333336,0,0,0,167.15047269584846,115.88764693607985"
                            strokeWidth={2}
                            opacity={0}
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              opacity: 0,
                            }}
                          />
                          <path
                            fill="#e085e4"
                            stroke="#ffffff"
                            d="M129.508,136.33333333333334A52.333333333333336,52.333333333333336,0,0,0,169.43954198140682,117.82676060111172L182.1565935678421,128.5996142957333A69,69,0,0,1,129.508,153Z"
                            strokeWidth={3}
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            }}
                          />
                          <path
                            fill="none"
                            stroke="#2a353a"
                            d="M167.15047269584846,115.88764693607985A49.333333333333336,49.333333333333336,0,0,0,141.98547595070528,36.2706550256831"
                            strokeWidth={2}
                            opacity={0}
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              opacity: 0,
                            }}
                          />
                          <path
                            fill="#2a353a"
                            stroke="#ffffff"
                            d="M169.43954198140682,117.82676060111172A52.333333333333336,52.333333333333336,0,0,0,142.74424138014004,33.36819485832599L146.95960487699992,17.2434161507865A69,69,0,0,1,182.1565935678421,128.5996142957333Z"
                            strokeWidth={3}
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            }}
                          />
                          <path
                            fill="none"
                            stroke="#c0e192"
                            d="M141.98547595070528,36.2706550256831A49.333333333333336,49.333333333333336,0,0,0,81.07574495358435,93.38586431271642"
                            strokeWidth={2}
                            opacity={0}
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              opacity: 0,
                            }}
                          />
                          <path
                            fill="#c0e192"
                            stroke="#ffffff"
                            d="M142.74424138014004,33.36819485832599A52.333333333333336,52.333333333333336,0,0,0,78.13054025481583,93.95662633173296L61.76829192832406,97.1275264373804A69,69,0,0,1,146.95960487699992,17.2434161507865Z"
                            strokeWidth={3}
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            }}
                          />
                          <path
                            fill="none"
                            stroke="#9568ff"
                            d="M81.07574495358435,93.38586431271642A49.333333333333336,49.333333333333336,0,0,0,129.4925014764973,133.33333089883092"
                            strokeWidth={2}
                            opacity={1}
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              opacity: 1,
                            }}
                          />
                          <path
                            fill="#9568ff"
                            stroke="#ffffff"
                            d="M78.13054025481583,93.95662633173296A52.333333333333336,52.333333333333336,0,0,0,129.49155899871673,136.33333075078687L129.48475221474592,157.99999634824638A74,74,0,0,1,56.85961743037653,98.07879646907463Z"
                            strokeWidth={3}
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            }}
                          />
                          {/* <text
                                x="129.508"
                                y={74}
                                textAnchor="middle"
                                fontFamily='"Arial"'
                                fontSize="15px"
                                stroke="none"
                                fill="#000000"
                                style={{
                                  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                  textAnchor: "middle",
                                  fontFamily: "Arial",
                                  fontSize: 15,
                                  fontWeight: 800
                                }}
                                fontWeight={800}
                                transform="matrix(0.5063,0,0,0.5063,63.9325,41.9608)"
                                strokeWidth="1.9749436936936935"
                              >
                                <tspan style={{ WebkitTapHighlightColor: "rgba(0, 0, 0, 0)" }} dy={6}>
                                  &nbsp; &nbsp; Mail-Order Sales &nbsp; &nbsp;
                                </tspan>
                              </text> */}
                          <text
                            x="129.508"
                            y={94}
                            textAnchor="middle"
                            fontFamily='"Arial"'
                            fontSize="14px"
                            stroke="none"
                            fill="#000000"
                            style={{
                              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              textAnchor: "middle",
                              fontFamily: "Arial",
                              fontSize: 14,
                            }}
                            transform="matrix(1.0278,0,0,1.0278,-3.6003,-2.3889)"
                            strokeWidth="0.9729729729729728"
                          >
                            <tspan
                              style={{
                                WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                              }}
                              dy={5}
                            >
                              ${dash.Net_Balance}
                            </tspan>
                          </text>
                        </svg>
                      </center>
                    </div>
                    <div className="chart-items">
                      <div className="row">
                        <div className=" col-xl-12 col-sm-12">
                          <div className="text-start">
                            {/* <span className="font-w600 mb-2 d-block text-secondary fs-14">
                                    <p className="text-black">Legend</p>
                                  </span> */}
                            <div className="color-picker">
                              <span className="mb-0 d-flex col-6 fs-14">
                                <div className="red"></div>
                                Total Income
                              </span>
                              <h5 className="text-black">
                                ${dash.TotalIncome}
                              </h5>
                            </div>
                            <div className="color-picker">
                              <span className="mb-0 d-flex col-6 fs-14">
                                <div className="red1"></div>
                                Total Withdrawal
                              </span>
                              <h5 className="text-black">
                                ${dash.WithDrawal_Amount}
                              </h5>
                            </div>
                            <div className="color-picker">
                              <span className="mb-0 d-flex col-6 fs-14">
                                <div className="red2"></div>
                                Net Balance
                              </span>
                              <h5 className="text-black">
                                ${dash.Net_Balance}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6">
                <div className="card bottomcard leftsidecardpoint">
                  <div class="card-heading mb-4 ms-3 mt-3">
                    <i class="fa fa-user tra"></i> News
                  </div>
                  <div className="card-body">
                    <div className="Ankercard">
                      <marquee
                        className="newsmarpuee text-black"
                        //width="40%"
                        direction="up"
                        height="222px"
                        scrollamount="3"
                      >
                        {News.map((item, index) => (
                          <h6
                            key={index}
                            className=""
                            dangerouslySetInnerHTML={{
                              __html: item.content,
                            }}
                            style={{ color: "black" }}
                          />
                        ))}
                      </marquee>
                      {/* <span>
                                    <img
                                      className="w-100 h-100"
                                      src={Arrow}
                                      alt=""
                                    />
                                  </span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mx-0 pt-3" style={{ display: "none" }}>
              <h2 className="text-dark">Fix Summary</h2>
              <div className="col-lg-12 ps-lg-0">
                <div className="row mx-0">
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/levelincome">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <div className="heading">{dash?.LevelIncome}</div>
                              <p>Grade Earning</p>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/Lifetimereward">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <div className="heading">
                                {dash?.Lifetimereward}
                              </div>
                              <p>Reward Income</p>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/ctoIncome">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <div className="heading">{dash?.CTOIncome}</div>
                              <p>Kingship Pool</p>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <a href="/royaltyIncome">
                      <div className="card samecard mb-3 w-100">
                        <div className="card-body">
                          <div className="row mx-0">
                            <div className="col-10 ps-0">
                              <div className="heading">{dash?.CTOIncome2}</div>
                              <p>INFINITY POOL </p>
                            </div>
                            <div className="col-2">
                              <div className="eyeimage">
                                <img className="w-100 h-100" src={Eye} alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="card samecard mb-3 w-100">
                      <div className="card-body">
                        <div className="row mx-0">
                          <div className="col-10 ps-0">
                            <div className="heading">{dash?.LegBusiness}</div>
                            <p>Reward Leg Business</p>
                          </div>
                          <div className="col-2">
                            <div className="eyeimage">
                              <img className="w-100 h-100" src={Eye} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="card samecard mb-3 w-100">
                      <div className="card-body">
                        <div className="row mx-0">
                          <div className="col-10 ps-0">
                            <div className="heading">
                              {dash?.Other_LegBusiness}
                            </div>
                            <p>Reward Other Leg Business</p>
                          </div>
                          <div className="col-2">
                            <div className="eyeimage">
                              <img className="w-100 h-100" src={Eye} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="card samecard mb-3 w-100">
                      <div className="card-body">
                        <div className="row mx-0">
                          <div className="col-10 ps-0">
                            {/* <div className="heading">{dash?.EarnPer} %</div> */}
                            <div className="heading"> {dash?.EarnAmount}</div>

                            <p>Earn</p>
                          </div>
                          <div className="col-2">
                            <div className="eyeimage">
                              <img className="w-100 h-100" src={Eye} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="card samecard mb-3 w-100">
                      <div className="card-body">
                        <div className="row mx-0">
                          <div className="col-10 ps-0">
                            {/* <div className="heading">{dash?.CapingPer} %</div> */}
                            <div className="heading">{dash?.MaxIncome}</div>
                            <p>Total Limit </p>
                          </div>
                          <div className="col-2">
                            <div className="eyeimage">
                              <img className="w-100 h-100" src={Eye} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
